import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface EntitySelectorButtonProps {
  selectedEntity: any;
  onSelect: () => void;
  onClear?: () => void;
  placeholder: string;
  icon: React.ComponentType<{ className?: string }>;
  getEntityName: (entity: any) => string;
  getEntityDescription: (entity: any) => string;
  iconColor?: string;
}

export default function EntitySelectorButton({
  selectedEntity,
  onSelect,
  onClear,
  placeholder,
  icon: Icon,
  getEntityName,
  getEntityDescription,
  iconColor = 'text-blue-600'
}: EntitySelectorButtonProps) {
  return (
    <div className="relative">
      <button
        type="button"
        onClick={onSelect}
        className="w-full px-4 py-3 text-left border border-gray-300 rounded-lg hover:border-gray-400 focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors bg-white"
      >
        {selectedEntity ? (
          <div className="flex items-center space-x-3">
            <Icon className={`h-5 w-5 ${iconColor}`} />
            <div>
              <span className="font-medium text-gray-900">{getEntityName(selectedEntity)}</span>
              <span className="block text-sm text-gray-500">{getEntityDescription(selectedEntity)}</span>
            </div>
          </div>
        ) : (
          <div className="flex items-center space-x-3 text-gray-500">
            <Icon className="h-5 w-5" />
            <span>{placeholder}</span>
          </div>
        )}
      </button>
      {selectedEntity && onClear && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onClear();
          }}
          className="absolute right-2 top-1/2 transform -translate-y-1/2 p-1 hover:bg-gray-100 rounded-full transition-colors"
          title="Clear selection"
        >
          <XMarkIcon className="h-4 w-4 text-gray-400 hover:text-gray-600" />
        </button>
      )}
    </div>
  );
}